<template>
  <div class="error-page">
    <ErrorScene
      code="404"
      description="抱歉！您所访问的页面不存在，请返回当前平台重新进入。"
      primary-text="返回登录页"
      primary-icon="el-icon-house"
      @primary="goLogin"
    />
  </div>
</template>

<script>
import { logout } from '@/api/api'
import { removeToken } from '@/utils/token'
import { resetRouter } from '@/router'
import ErrorScene from '@/components/error/ErrorScene'

export default {
  name: 'NotFoundPage',
  components: {
    ErrorScene
  },
  methods: {
    resetSession() {
      this.$store.commit('user/setToken', '')
      this.$store.commit('user/setUser', '')
      this.$store.commit('menu/setMenus', [])
      this.$store.commit('menu/setRoutes', [])
      this.$store.commit('menu/setDisplayMenus', [])
      this.$store.commit('menu/setBtnMenus', [])
      this.$store.commit('menu/setActiveMenuArrary', [])
      this.$store.commit('menu/setActiveMenu', '/index')
      this.$store.commit('menu/setFlag', false)
      removeToken()
      resetRouter()
    },
    goLogin() {
      logout().catch(() => {}).finally(() => {
        this.resetSession()
        this.$router.replace('/login').catch(() => {})
      })
    }
  }
}
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  box-sizing: border-box;
  background:
    radial-gradient(circle at top, rgba(233, 239, 255, 0.92) 0, rgba(244, 247, 255, 0.98) 40%, #f7f9ff 100%);
}
</style>
